import React from 'react';
import { LogoIcon } from './LogoIcon';
export function Footer() {
  return <footer className="relative bg-gradient-to-b from-apple-light to-gray-100 pt-16 pb-8 px-4 sm:px-6 lg:px-8" data-id="element-123">
      {/* Gradient top border */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent" data-id="element-124" />

      <div className="max-w-7xl mx-auto" data-id="element-125">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-8" data-id="element-126">
          <div className="flex items-center gap-3" data-id="element-127">
            <LogoIcon size={32} data-id="element-128" />
            <span className="text-sm font-bold text-apple-black tracking-tight" data-id="element-129">
              Larsen Evans Enterprise
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm text-apple-gray" data-id="element-130">
            <a href="https://cloud-sparkle-nexus.lovable.app" target="_blank" rel="noopener noreferrer" className="font-semibold hover:text-apple-blue transition-colors duration-300" data-id="element-131">
              ☁️ Cloud LE/AI
            </a>
            <a href="#engine" className="hover:text-apple-black transition-colors duration-300" data-id="element-132">
              Engine
            </a>
            <a href="#pwa" className="hover:text-apple-black transition-colors duration-300" data-id="element-133">
              PWA
            </a>
            <a href="#portfolio" className="hover:text-apple-black transition-colors duration-300" data-id="element-134">
              Portfólio
            </a>
            <a href="#kontakt" className="hover:text-apple-black transition-colors duration-300" data-id="element-135">
              Kontakt
            </a>
          </div>
        </div>

        <div className="h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-8" data-id="element-136" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-apple-gray" data-id="element-137">
          <p data-id="element-138">
            Copyright © 2026 Larsen Evans Enterprise Inc. Všetky práva
            vyhradené.
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-139">
            <a href="#" className="hover:text-apple-black transition-colors duration-300" data-id="element-140">
              Ochrana Súkromia
            </a>
            <a href="#" className="hover:text-apple-black transition-colors duration-300" data-id="element-141">
              Podmienky Používania
            </a>
            <a href="#" className="hover:text-apple-black transition-colors duration-300" data-id="element-142">
              Mapa Stránky
            </a>
          </div>
        </div>
      </div>
    </footer>;
}